import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@modules/auth/auth.service';

@Component({
    selector: 'app-quotation-success',
    templateUrl: './quotation-success.component.html',
    styleUrls: ['./quotation-success.component.scss']
})
export class QuotationSuccessComponent {
    status: 'success' | 'failed' = 'success';
    userRole: string | null = null;
    constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService,) { }

    ngOnInit(): void {
        this.userRole = this.authService.getUserRole();
        this.route.queryParams.subscribe(params => {
            this.status = params['status'] === 'failed' ? 'failed' : 'success';
        });
    }

    goHome() {
        const role = this.authService.getUserRole();
        const backOffice = ['Sale', 'Agent', 'SuperAdmin', 'Admin'];

        if (role && backOffice.includes(role)) {
            this.router.navigate(['/quotation/listing']);
        } else {
            this.router.navigate(['/requestquotation']);
        }
    }
}